<p-dialog [(visible)]="displayDialog" [style]="{ width: '30vw' }" [modal]="true" [draggable]="false" [resizable]="false"
    [closable]="true" (onHide)="onDialogClosed()" header="Tipos de Cuestionario">
    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" type="button" (click)="openNew()" [disabled]="cuestionario?.iTipo === 0 || cuestionario?.iTipo === '0'" appPermissionControl="P282B0001">
            <mat-icon>add</mat-icon>
            Nuevo
        </button>
    </div>

    <p-table #dt [value]="tipos" [columns]="displayedColumns" [scrollable]="true" [scrollHeight]="'calc(100vh - 400px)'"
        styleClass="p-datatable-gridlines" [resizableColumns]="true" [autoLayout]="true" responsiveLayout="scroll"
        [loading]="loading" appPermissionControl="P282T0001">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of displayedColumns" class="th-prime" appPermissionControl="P282C0001">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tipo>
            <tr>
                <td *ngFor="let col of displayedColumns" class="td-prime">
                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'actions'">
                            <div class="d-flex gap-2 justify-content-center">
                                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text"
                                    (click)="deleteTipo(tipo)" pTooltip="Eliminar" appPermissionControl="P282B0002"></button>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ tipo[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2" class="text-center td-prime">
                    <span *ngIf="tipos.length === 0 && !loading">No hay datos para mostrar</span>
                    <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                        fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<app-nuevo-tipo-dialog
    [(displayDialog)]="displayNuevoTipoDialog"
    [cuestionario]="cuestionario"
    (onHide)="onNuevoTipoDialogClosed($event)"
></app-nuevo-tipo-dialog>

<p-toast position="bottom-right"></p-toast>